"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHelmetAsync = require("react-helmet-async");

var _uiKit = require("@dbi-tools/ui-kit");

var _notification = require("@dbi-tools/ui-kit/lib/components/notification");

var _themeOptions = require("../../helpers/theme-options");

var _const = require("../../const");

var _useStyles = require("../../hooks/useStyles");

var _headerTitles = require("../header-titles");

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

var _gallery = require("./gallery.styled");

var _const2 = require("./const");

var _style = _interopRequireDefault(require("./style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Gallery = function Gallery(props) {
  var _props$theme = props.theme,
      currentTheme = _props$theme === void 0 ? _const2.GalleryThemeVariants.WHITE : _props$theme,
      id = props.id,
      headline1 = props.headline1,
      headline2 = props.headline2,
      description = props.description,
      removeTopPadding = props.removeTopPadding,
      removeBottomPadding = props.removeBottomPadding,
      _props$galleryTag = props.galleryTag,
      galleryTag = _props$galleryTag === void 0 ? '' : _props$galleryTag,
      _props$buttons = props.buttons,
      buttons = _props$buttons === void 0 ? [] : _props$buttons;
  var _themeStrategy$curren = _themeOptions.themeStrategy[currentTheme],
      headline1Color = _themeStrategy$curren.headline1Color,
      headline2Color = _themeStrategy$curren.headline2Color,
      size = _themeStrategy$curren.size,
      type = _themeStrategy$curren.type;
  var basicStyles = (0, _useStyles.useStyles)('a', _style.default);

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      backDropHeight = _useState2[0],
      setBackDropHeight = _useState2[1];

  var isDarkTheme = type === _themeOptions.ThemeType.DARK;
  var isCroppedTheme = size === _themeOptions.ThemeSize.CROPPED || currentTheme === _const2.GalleryThemeVariants.WHITE;
  var theme = {
    $theme: currentTheme,
    $styles: basicStyles,
    $backDropHeight: backDropHeight,
    $currentTheme: currentTheme,
    $isCroppedTheme: isCroppedTheme
  };

  var isValidHTML = function isValidHTML(html) {
    var regex = new RegExp(/<(“[^”]*”|'[^’]*’|[^'”>])*>/);
    return regex.test(html);
  };

  (0, _react.useEffect)(function () {
    if (!isCroppedTheme) setBackDropHeight(0);
    setBackDropHeight(_const2.BACKDROP_OFFSET);
  }, [currentTheme, removeTopPadding]);
  return /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.HelmetProvider, null, /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.Helmet, null, /*#__PURE__*/_react.default.createElement("script", null, _const2.GALLERY_SCRIPT)), /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_gallery.ComponentStyled, {
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_GALLERY,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_gallery.StyledHead, {
    removeTopPadding: removeTopPadding
  }, /*#__PURE__*/_react.default.createElement(_gallery.ContainerStyled, null, /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    headline1: headline1,
    headline2: headline2,
    description: description,
    headline1Color: isDarkTheme ? 'white' : headline1Color,
    headline2Color: isDarkTheme ? 'white' : headline2Color,
    fullWidth: true
  }))), /*#__PURE__*/_react.default.createElement(_gallery.StyledContent, {
    removeBottomPadding: removeBottomPadding
  }, /*#__PURE__*/_react.default.createElement(_gallery.ContainerStyled, null, isValidHTML(galleryTag) ? /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    mt: 30,
    p: [0, 15],
    dangerouslySetInnerHTML: {
      __html: galleryTag.replace(/[“”`]/g, '"')
    }
  }) : galleryTag && /*#__PURE__*/_react.default.createElement(_gallery.NotificationWrapStyled, null, /*#__PURE__*/_react.default.createElement(_notification.Notification, {
    title: "Gallery tag is not valid",
    type: "error"
  })), !!buttons.length && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    display: "inline-block",
    align: "center",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    buttons: buttons,
    mt: 35
  })))))));
};

var _default = Gallery;
exports.default = _default;